import axios from 'axios';
import { Helpers } from '../helpers/Helpers';
import { GetRoleListPagingAndFilterRequest } from '../models/request/role/GetRoleListPagingAndFilterRequest';

export class RoleService {
    static async getRoleListPagingAndFilter(inputObj: GetRoleListPagingAndFilterRequest) {
        try {
            console.log('SERVICE CALL - GetRoleListPagingAndFilter', JSON.stringify(inputObj));

            const resp = await axios.post(Helpers.getEndpoint() + '/Role/GetRoleListPagingAndFilter', inputObj);

            return Helpers.dataParser(resp);
        } catch (error) {
            throw Helpers.parseErrorMessage(error);
        }
    }

    static async exportRoleList(inputObj: GetRoleListPagingAndFilterRequest) {
        try {
            console.log('SERVICE CALL - exportRoleList', JSON.stringify(inputObj));

            const resp = await axios.post(Helpers.getEndpoint() + '/Role/exportRoleList', inputObj);

            return Helpers.dataParser(resp);
        } catch (error) {
            throw Helpers.parseErrorMessage(error);
        }
    }

    /** companyId verilirse o şirketin (ve ortak) rolleri gelir; verilmezse ekranda seçili firmanınkiler. */
    static async getRoleList(companyId?: string) {
        try {
            var inputObj = {
                companyId: companyId
            };

            console.log('SERVICE CALL - getRoleList', JSON.stringify(inputObj));

            const resp = await axios.post(Helpers.getEndpoint() + '/Role/getRoleList', inputObj);

            return Helpers.dataParser(resp);
        } catch (error) {
            throw Helpers.parseErrorMessage(error);
        }
    }

    static async addRole(_roleId: string | undefined, _roleName: string | undefined) {
        try {
            var inputObj = {
                roleId: _roleId,
                name: _roleName,
            }

            console.log('SERVICE CALL - AddRole', JSON.stringify(inputObj));

            const resp = await axios.post(Helpers.getEndpoint() + '/Role/AddRole', inputObj);

            return Helpers.dataParser(resp);
        } catch (error) {
            throw Helpers.parseErrorMessage(error);
        }
    }

    static async deleteRole(_ids: string[]) {
        try {
            var inputObj = {
                ids: _ids
            };

            console.log('SERVICE CALL - deleteRole', JSON.stringify(inputObj));

            const resp = await axios.post(Helpers.getEndpoint() + '/Role/deleteRole', inputObj);

            return Helpers.dataParser(resp);
        } catch (error) {
            throw Helpers.parseErrorMessage(error);
        }
    }

    static async getRoleById(_id: string) {
        try {
            var inputObj = {
                id: _id
            };

            console.log('SERVICE CALL - getRoleById', JSON.stringify(inputObj));

            const resp = await axios.post(Helpers.getEndpoint() + '/Role/getRoleById', inputObj);

            return Helpers.dataParser(resp);
        } catch (error) {
            throw Helpers.parseErrorMessage(error);
        }
    }
}